import { MuiSwitch } from '@/features/shared/material-ui';
import { BackgroundColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';
import { withStyles } from '@material-ui/styles';

export default withStyles(() => ({
  root: {
    marginTop: '-6px',
    marginLeft: '-8px',
  },
  track: { backgroundColor: hexToRGBA(TextColors.light, TextOpacities.light2) },
  switchBase: {
    '&, &.Mui-checked': {
      color: BackgroundColors.light,
    },
    '&.Mui-checked + .MuiSwitch-track': {
      opacity: 'initial',
    },
  },
}))(MuiSwitch);
